import { render } from "./ImportStudent.vue?vue&type=template&id=12b3c71a&scoped=true"
import script from "./ImportStudent.vue?vue&type=script&lang=js"
export * from "./ImportStudent.vue?vue&type=script&lang=js"

import "./ImportStudent.vue?vue&type=style&index=0&id=12b3c71a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b3c71a"]])

export default __exports__